<template>
<div class="home">
  <div class="order-header">
    <div class="order-header-title">
      <div class="order-header-content">
        <div class="order-header-img"><van-icon name="passed" /></div>
        <div class="order-header-text" v-if="payStatus == 2">
          <span>等待退款</span>
        </div>
        <div class="order-header-text" v-else>
          <span v-if="orStatusType == 0">待支付</span>
          <span v-if="orStatusType == 1">待发货</span>
          <span v-if="orStatusType == 2">待收货</span>
          <span v-if="orStatusType == 3">收货待付款</span>
          <span v-if="orStatusType == 4">已完成</span>
          <span v-if="orStatusType == 5">已取消</span>
        </div>
      </div>
    </div>
  </div>
  <div class="order-info">
    <div class="order-info-box">
      <div class="info-box">
        <div class="order-info-title">订单编号:</div>
        <div class="order-info-text">{{orderNum}}</div>
      </div>
      <div class="info-box">
        <div class="order-info-title">下单时间:</div>
        <div class="order-info-text">{{orderTime}}</div>
      </div>
      <div class="info-box">
        <div class="order-info-title">支付方式:</div>
        <div class="order-info-text">
          <span v-if="orderPaytype == 'wx'">微信</span>
          <span v-if="orderPaytype == 'alipay'">支付宝</span>
          <span v-if="orderPaytype == 'upacp'">银联</span>
          <span v-if="orderPaytype == 'pub_account'">账户余额</span>
        </div>
      </div>
      <div class="info-box">
        <div class="order-info-title">支付时间:</div>
        <div class="order-info-text">{{orPayTime}}</div>
      </div>
      <div class="info-box">
        <div class="order-info-title">配送方式:</div>
        <div class="order-info-text">{{logisticsCmpy}}</div>
      </div>
    </div>
  </div>
  <div class="order-address">
    <div class="order-address-box">
      <div class="address-icon"><van-icon name="location-o" /></div>
      <div class="address-content">
        <div class="address-name">{{orderReceivers}} {{orderReceiverTel}}</div>
        <div class="address-text">地址：{{orderAddr}}</div>
      </div>
    </div>
  </div>
  <div class="order-company">
    <div class="order-company-box">
      <div class="order-shop-company">
        <div class="company-img">
          <van-icon name="newspaper-o" />
        </div>
        <div class="company-title">
          <span>{{goodsCompanyName}}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="order-shop" v-for="(item,i) in goodsList" :key="i">
    <div class="order-shop-box">
      <div class="order-shop-list">
        <div class="order-express-title">子订单号: {{item.orderNum}}</div>
        <div class="order-express-title">配送方式:<strong>{{item.logisticsCmpy?item.logisticsCmpy:'无'}}</strong></div>
        <div class="shop-list" v-for="(item1,j) in item.orGoodsBos" :key="j">
          <!-- 商品 -->
          <div class="shop-list-content">
            <div class="order-shop-img">
              <img :src="item1.orderImg">
            </div>
            <div class="order-shop-content">
              <div class="order-shop-title">{{item1.orderPdCname}}</div>
              <div class="order-shop-spec">规格包装：{{item1.orderPdPack}}</div>
              <div class="order-shop-price">
                <div class="shop-price">¥{{item1.orderPdPrice | priceFloat}}</div>
                <div class="shop-num">X{{item1.orderPdCount}}</div>
              </div>
            </div>
          </div>
          <!-- 满赠 -->
          <div  v-if="item1.giveGoodsInfoBos.length > 0">
            <div v-for="(item2,a) in item1.giveGoodsInfoBos" :key="a">
              <div class="shop-list-activity" v-for="(item3,a1) in item2.giveGoodsBos" :key="a1">
                <div class="shop-activity-title">
                  <span>满赠</span>
                  <strong>{{item3.giveTitle}}</strong>
                </div>
                <div class="shop-activity-content">
                  <div class="order-shop-img">
                    <img :src="item3.goodsImg">
                  </div>
                  <div class="order-shop-content">
                    <div class="order-shop-title">{{item3.goodsName}}</div>
                    <div class="order-shop-spec">规格包装：{{item3.goodsSpec}}</div>
                    <div class="order-shop-price">
                      <div class="shop-price">¥{{item3.goodsPrice | priceFloat}}</div>
                      <div class="shop-num">X{{item3.goodsNum}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 礼品 -->
          <div v-if="item1.giftGoodsInfoBos.length > 0">
            <div v-for="(item4,b) in item1.giftGoodsInfoBos" :key="b">
              <div class="shop-list-activity" v-for="(item5,b1) in item4.giftGoodsBos" :key="b1">
                <div class="shop-activity-title">
                  <span>礼品</span>
                  <strong>{{item5.giveTitle}}</strong>
                </div>
                <div class="shop-activity-content">
                  <div class="order-shop-img">
                    <img :src="item5.goodsImg">
                  </div>
                  <div class="order-shop-content">
                    <div class="order-shop-title">{{item5.goodsName}}</div>
                    <div class="order-shop-spec">规格包装：{{item5.goodsSpec}}</div>
                    <div class="order-shop-price">
                      <div class="shop-price">¥{{item5.goodsPrice | priceFloat}}</div>
                      <div class="shop-num">X{{item5.goodsNum}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="order-message">
    <div class="order-message-box">
      <div class="message-title">买家留言</div>
      <div class="message-text">{{message}}</div>
    </div>
  </div> -->
  <div class="order-money">
    <div class="order-money-box">
      <div class="money-box">
        <div class="order-money-title">商品金额:</div>
        <div class="order-money-text">¥{{totalBeforeAmount}}</div>
      </div>
      <div class="money-box">
        <div class="order-money-title">运费:</div>
        <div class="order-money-text">+ ¥{{orderFripay}}</div>
      </div>
      <div class="money-box">
        <div class="order-money-title">立减:</div>
        <div class="order-money-text">- ¥{{orderCut}}</div>
      </div>
      <div class="money-box">
        <div class="order-money-title">优惠券:</div>
        <div class="order-money-text">- ¥{{orderCoupon}}</div>
      </div>
      <div class="order-money-total">应付款：<span>¥{{totalAmount}}</span></div>
    </div>
  </div>
</div>
</template>

<script>
import md5 from 'js-md5';
import { orderDetail } from '@/api/resetApi.js'

export default {
  name: 'shopdetails',
  data() {
    return {
      orderId: '',
      customerCode: '',
      date: '',
      datemd5: '',
      orStatusType: '',
      message: '',
      orderNum: '',
      orderTime: '',
      orderPaytype: '',
      orPayTime: '',
      logisticsCmpy: '',
      orderReceivers: '',
      orderReceiverTel: '',
      orderAddr: '',
      totalBeforeAmount: '',
      orderFripay: '',
      orderCut: '',
      orderCoupon: '',
      totalAmount: '',
      goodsCompanyName: '',
      payStatus: '',
      goodsList: [],
    }
  },
  created(){
    this.orderId = this.$route.query.orderId
    this.customerCode = this.$route.query.customerCode
    this.date = this.$route.query.date
    this.datemd5 = md5(this.orderId+this.customerCode+this.date).substring(0,6)
    console.log('datemd5',this.datemd5)
    this.getOrderDetail()
  },
  methods: {
    async getOrderDetail() {
      let data = {
        orderId: this.orderId,
        customerCode: this.customerCode,
        date: this.date,
        token: this.datemd5,
      }
      const res = await orderDetail(data)
      console.log(res)
      try {
        if (res.data.code === 200) {
          let reg = /(\d{3})\d{4}(\d{4})/;
          this.orStatusType = res.data.data.orStatusType
          this.payStatus = res.data.data.payStatus
          this.orderNum = res.data.data.orderNum
          this.orderTime = res.data.data.orderTime
          this.orderPaytype = res.data.data.orderPaytype
          this.orPayTime = res.data.data.orPayTime
          this.logisticsCmpy = res.data.data.logisticsCmpy
          this.orderReceivers = res.data.data.orderReceivers
          this.orderReceiverTel = res.data.data.orderReceiverTel.replace(reg, "$1****$2")
          this.orderAddr = res.data.data.orderAddr
          this.message = res.data.data.message
          this.totalBeforeAmount = res.data.data.totalBeforeAmount.toFixed(2)
          this.totalAmount = res.data.data.totalAmount.toFixed(2)

          this.orderFripay = res.data.data.orderFripay?res.data.data.orderFripay.toFixed(2):'0.00'
          this.orderCut = res.data.data.orderCut?res.data.data.orderCut.toFixed(2):'0.00'
          this.orderCoupon = res.data.data.orderCoupon?res.data.data.orderCoupon.toFixed(2):'0.00'
          this.totalAmount = res.data.data.totalAmount?res.data.data.totalAmount.toFixed(2):'0.00'

          this.goodsCompanyName = res.data.data.orgName
          this.goodsList = res.data.data.orgOrderGoodsBos
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  max-width: 780px;
  margin: 0 auto;
  padding-bottom: 0.2rem;
  background: rgba(249,249,249,1);
}
.order-header {
  width: 100%;
  height: 2rem;
  // line-height: 210px;
  font-size: 0;
  text-align: center;
  background: linear-gradient(315deg,rgba(250,101,101,1) 0%,rgba(219,46,46,1) 100%);
  .order-header-title {
    display: inline-block;
    margin-top: 1rem;
    height: 0.25rem;
    .order-header-content {
      font-size: 0;
      .order-header-img {
        display: inline-block;
        font-size: 0.2rem;
        color: #fff;
      }
      .order-header-text {
        display: inline-block;
        vertical-align: top;
        margin-left: 0.05rem;
        font-size: 0.18rem;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(255,255,255,1);
      }
    }
  }
}
.order-info {
  margin-top: -0.4rem;
  padding: 0 0.15rem;
  .order-info-box {
    padding: 0.1rem;
    border-radius: 0.14rem;
    background: #fff;
    .info-box {
      display: flex;
      padding: 0.1rem 0;
      .order-info-title {
        flex: 0 0 0.6rem;
        font-size: 0.14rem;
        color:rgba(155,155,155,1);
      }
      .order-info-text {
        flex: 1;
        margin-left: 0.1rem;
        text-align: left;
        font-size: 0.14rem;
        color:rgba(24,24,24,1);
      }
    }
  }
}
.order-address {
  margin: 0.1rem 0;
  padding: 0 0.15rem;
  .order-address-box {
    display: flex;
    padding: 0.2rem 0.1rem;
    border-radius: 0.14rem;
    background: #fff;
    .address-icon {
      flex: 0 0 0.2rem;
      font-size: 0.14rem;
      font-weight: bold;
    }
    .address-content {
      flex: 1;
      text-align: left;
      .address-name {
        font-size: 0.14rem;
        color: #181818;
      }
      .address-text {
        padding-top: 0.2rem;
        font-size: 0.12rem;
        color: #9B9B9B;
      }
    }
  }
}
.order-company {
  margin-bottom: 0.1rem;
  padding: 0 0.15rem;
  .order-company-box {
    padding: 0.1rem 0;
    border-radius: 0.14rem;
    background: #fff;
    .order-shop-company {
      display: flex;
      padding: 0.1rem 0.05rem;
      .company-img {
        flex: 0 0 0.2rem;
        font-size: 0.14rem;
      }
      .company-title {
        flex: 1;
        text-align: left;
        font-size: 0.14rem;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(74,74,74,1);
      }
    }
  }
}
.order-shop {
  margin-bottom: 0.1rem;
  padding: 0 0.15rem;
  .order-shop-box {
    padding: 0.2rem 0.1rem;
    border-radius: 0.14rem;
    background: #fff;
    .order-express-title {
      padding-bottom: 0.1rem;
      text-align: left;
      font-size: 0.14rem;
      color: #4a4a4a;
      strong {
        margin-left: 0.05rem;
        font-weight: bold;
      }
    }
    .order-shop-list {
      .shop-list {
        padding-top: 0.1rem;
        border-top: 0.01rem solid #eee;
        .shop-list-content {
          display: flex;
          padding: 0.05rem 0 0.15rem;
          border-bottom: 0.01rem solid #eee;
          // &:last-child {
          //   border-bottom: 0;
          // }
          .order-shop-img {
            flex: 0 0 0.8rem;
            align-self: center;
            height: 0.8rem;
            font-size: 0;
            img {
              width: 0.8rem;
              height: 0.8rem;
            }
          }
          .order-shop-content {
            flex: 1;
            position: relative;
            margin-left: 0.1rem;;
            // align-self: center;
            text-align: left;
            .order-shop-title {
              display: -webkit-box;
              overflow: hidden;
              text-overflow: ellipsis;
              word-wrap: break-word;
              white-space: normal !important;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              line-height: 0.18rem;
              font-size: 0.14rem;
              font-weight:400;
              color:rgba(24,24,24,1);
            }
            .order-shop-spec {
              padding-top: 0.05rem;
              font-size: 0.12rem;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400;
              color:rgba(155,155,155,1);
            }
            .order-shop-price {
              position: absolute;
              bottom: 0;
              display: flex;
              width: 100%;
              .shop-price {
                flex: 1;
                text-align: left;
                font-size: 0.14rem;
                font-family:PingFangSC-Medium,PingFang SC;
                font-weight:500;
                color:#d0021b;
              }
              .shop-num {
                flex: 1;
                text-align: right;
                font-size: 0.12rem;
                color:#9b9b9b;
              }
            }
          }
        }

        .shop-list-activity {
          font-size: 0;
          padding-bottom: 0.1rem;
          border-bottom: 1px solid #eee;
          .shop-activity-title {
            padding: 0.15rem 0;
            text-align: left;
            span {
              display: inline-block;
              padding: 0.03rem 0.05rem;
              border-radius: 0.05rem;
              font-size: 0.12rem;
              font-weight: bold;
              color: #fff;
              background: #d0021b;
            }
            strong {
              margin-left: 0.05rem;
              font-size: 0.14rem;
              color: #4a4a4a;
              font-weight: 500;
            }
          }
          .shop-activity-content {
            display: flex;
            padding: 0.05rem 0;
            // border-bottom: 1px solid #D1D1D1;
            // &:last-child {
            //   border-bottom: 0;
            // }
            .order-shop-img {
              flex: 0 0 0.8rem;
              align-self: center;
              height: 0.8rem;
              font-size: 0;
              img {
                width: 0.8rem;
                height: 0.8rem;
              }
            }
            .order-shop-content {
              flex: 1;
              position: relative;
              margin-left: 0.1rem;
              // align-self: center;
              text-align: left;
              .order-shop-title {
                display: -webkit-box;
                overflow: hidden;
                text-overflow: ellipsis;
                word-wrap: break-word;
                white-space: normal !important;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                line-height: 0.18rem;
                font-size: 0.14rem;
                font-weight:400;
                color:rgba(24,24,24,1);
              }
              .order-shop-spec {
                padding-top: 0.05rem;
                font-size: 0.12rem;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                color:rgba(155,155,155,1);
              }
              .order-shop-price {
                position: absolute;
                bottom: 0;
                display: flex;
                width: 100%;
                .shop-price {
                  flex: 1;
                  text-align: left;
                  font-size: 0.14rem;
                  font-family:PingFangSC-Medium,PingFang SC;
                  font-weight:500;
                  color:#d0021b;
                }
                .shop-num {
                  flex: 1;
                  text-align: right;
                  font-size: 0.12rem;
                  color:#9b9b9b;
                }
              }
            }
          }
        }
      }
    }
  }
}
.order-message {
  padding: 0 0.15rem;
  .order-message-box {
    padding: 0.2rem 0.1rem;
    border-radius: 0.14rem;
    background: #fff;
    text-align: left;
    .message-title {
      padding-left: 0.1rem;
      border-left: 0.02rem solid #EA4747;
      font-family:PingFangSC-Semibold,PingFang SC;
      font-size: 0.12rem;
      font-weight:bold;
      color:rgba(24,24,24,1);
    }
    .message-text {
      padding: 0.1rem 0.1rem 0 0.1rem;
      font-family:PingFangSC-Semibold,PingFang SC;
      font-size: 0.14rem;
      font-weight:400;
      color:rgba(74,74,74,1);
    }
  }
}
.order-money {
  margin: 0.1rem 0 0.2rem;
  padding: 0 0.15rem;
  .order-money-box {
    padding: 0.1rem 0.2rem;
    border-radius: 0.14rem;
    background: #fff;
    .money-box {
      display: flex;
      padding: 0.1rem 0;
      .order-money-title {
        flex: 0 0 0.6rem;
        text-align: left;
        font-size: 0.14rem;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(74,74,74,1);
      }
      .order-money-text {
        flex: 1;
        text-align: right;
        font-size: 0.14rem;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(24,24,24,1);
      }
    }
    .order-money-total {
      padding: 0.05rem 0 0.1rem 0;
      text-align: right;
      font-size: 0.14rem;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(24,24,24,1);
      span {
        color: #EA4747;
      }
    }
  }
}
</style>